import React, { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { Button, Card } from 'components'
import { readMessage, removeMessage } from 'slices/messages'
import { clearHistory, goBack, setDrawer, setStage } from 'slices/drawer'
import { formatDate } from 'utils'
import {
  DRAWER_KEY,
  FIREBASE_EVENTS,
  INTERNAL_REDIRECT_TYPE,
  NOTIFICATION_CTA_DEFAULT,
} from 'app-constants'
import { useFirebaseEvent, useRedirect } from 'hooks'
import { STATICS } from 'statics'
import { MESSAGES_DRAWER_STAGES } from '../../constants'
import './style.scss'

export function Message({ selected }) {
  const { redirectScreen, redirectLabel } = selected
  const dispatch = useDispatch()
  const { sendEvent } = useFirebaseEvent()
  const { handleCtaRedirect } = useRedirect(INTERNAL_REDIRECT_TYPE.DRAWER, handleTypeChange)

  useEffect(() => {
    if (!selected.visualized) {
      dispatch(readMessage(selected.id))
    }
  }, [selected.id, dispatch, selected.visualized])

  function handleDelete() {
    sendEvent(FIREBASE_EVENTS.NOTIFICATION_DELETE)
    dispatch(removeMessage(selected.id))
    dispatch(setStage(MESSAGES_DRAWER_STAGES.INITIAL))
    dispatch(clearHistory())
  }

  function handleCtaClick() {
    if (!redirectScreen) {
      dispatch(goBack())
      return
    }

    handleCtaRedirect(redirectScreen)
  }

  function handleTypeChange() {
    dispatch(setDrawer(DRAWER_KEY.NONE))
  }

  function renderCta() {
    return (
      <Button color='primary' className='cta-button' onClick={handleCtaClick} size='large'>
        {redirectLabel || NOTIFICATION_CTA_DEFAULT}
      </Button>
    )
  }

  return (
    <div className='message-details-component'>
      <h3 className='title-drawer'>Central de Notificações</h3>
      <Card className='card'>
        <p className='title'>{selected.title}</p>
        {selected.imageUrl && <img alt={selected.title} src={selected.imageUrl} />}
        <p className='text description'>{selected.description}</p>
        {selected.launchUrl && (
          <a className='link' rel='noopener noreferrer' href={selected.launchUrl} target='_blank'>
            {' '}
            {selected.launchUrl}
          </a>
        )}
        <div className='box'>
          <p className='date text'>{formatDate(selected.creationDateTime)}</p>
          <STATICS.DELETE onClick={() => handleDelete()} />
        </div>
      </Card>
      {renderCta()}
    </div>
  )
}
